var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPercentageArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.74905 21C3.55014 21 3.35937 20.921 3.21872 20.7803C3.07807 20.6397 2.99905 20.4489 2.99905 20.25V11.25C2.99905 11.0511 3.07807 10.8603 3.21872 10.7196C3.35937 10.579 3.55014 10.5 3.74905 10.5C3.94796 10.5 4.13873 10.579 4.27938 10.7196C4.42003 10.8603 4.49905 11.0511 4.49905 11.25V18.4395L19.7181 3.21897C19.7878 3.14924 19.8706 3.09392 19.9617 3.05619C20.0528 3.01845 20.1504 2.99902 20.2491 2.99902C20.3477 2.99902 20.4453 3.01845 20.5364 3.05619C20.6275 3.09392 20.7103 3.14924 20.7801 3.21897C20.8498 3.2887 20.9051 3.37149 20.9428 3.4626C20.9806 3.5537 21 3.65136 21 3.74997C21 3.84859 20.9806 3.94624 20.9428 4.03735C20.9051 4.12846 20.8498 4.21124 20.7801 4.28097L5.55955 19.5H12.7491C12.948 19.5 13.1387 19.579 13.2794 19.7196C13.42 19.8603 13.4991 20.0511 13.4991 20.25C13.4991 20.4489 13.42 20.6397 13.2794 20.7803C13.1387 20.921 12.948 21 12.7491 21H3.74905Z",
    fill: "#008000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentageArrow);
export default __webpack_public_path__ + "static/media/percentage_arrow.a6a07ed6c9f59a05d6e66ee2ef09db96.svg";
export { ForwardRef as ReactComponent };